import React from 'react'
import { icons } from '../../Assets/Icons/icons'

const StarRating = ({ rating }) => {
  return (
    Array(5).fill('').map((_, index) => (
      index < rating ? <span className='text-black'>{icons.starIcon}</span> : <span className='text-secondaryTextColor'>{icons.starIcon}</span>
    ))
  )
}

export default StarRating